import { useEphattaQuery } from "../../.."
import { useAdvertEquipmentsService } from "./useAdvertEquipmentsService"

export const useAdvertEquipments = () => {
    const service = useAdvertEquipmentsService()
    return useEphattaQuery("Adverts.Equipments", () => service.getAll(),)
} 